var map = {
	"./wbicon-baiyun.jpg": "7f42",
	"./wbicon-conghua.jpg": "95a4",
	"./wbicon-guangzhou.jpg": "49f0",
	"./wbicon-huadu.jpg": "7929",
	"./wbicon-huangpu.jpg": "97e2",
	"./wbicon-nansha.jpg": "6b00",
	"./wbicon-panyu.jpg": "3201",
	"./wbicon-zengcheng.jpg": "bfb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8d4";